
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/course/[coursePath]/certificate-of-completion",
      function () {
        return require("private-next-pages/school/course/[coursePath]/certificate-of-completion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/course/[coursePath]/certificate-of-completion"])
      });
    }
  